import { BookTicketByTheaterPage } from '@/components/pages/book-ticket-theater'
import { Meta } from '@/layouts'
import { MainLayout } from '@/layouts/main-layout'
import { listCinema } from '@/services'
import { TNextPageWithLayout } from '@/types/layout'

const BookTicketTheater: TNextPageWithLayout = (props: any) => {
  return (
    <>
      <Meta title='Cinestar - Chọn rạp phim' description='Cinestar - Hệ thống rạp chiếu phim giá rẻ, hiện đại bật nhất nhất' canonical={process.env.NEXT_PUBLIC_DEPLOY_URL + 'book-tickets'} />
      <BookTicketByTheaterPage data={props.listCinemaData } />
    </>
  )
}

BookTicketTheater.Layout = MainLayout

export default BookTicketTheater

export const getStaticProps = async () => {
  const listCinemaData = await listCinema.getListCinema().then((res: any) => {
    return res?.cinemas
  })
  return {
    props: { listCinemaData },
    revalidate: 20,
  }
}
